import "./index.css";
import {jsx as $4MPRY$jsx, jsxs as $4MPRY$jsxs} from "react/jsx-runtime";
import $4MPRY$react, {useEffect as $4MPRY$useEffect, useState as $4MPRY$useState, useRef as $4MPRY$useRef, useMemo as $4MPRY$useMemo} from "react";
import {Provider as $4MPRY$Provider, useDispatch as $4MPRY$useDispatch, useSelector as $4MPRY$useSelector} from "react-redux";
import {configureStore as $4MPRY$configureStore, createSlice as $4MPRY$createSlice} from "@reduxjs/toolkit";
import {createRoot as $4MPRY$createRoot} from "react-dom/client";

/* eslint-disable prettier/prettier */ 




const $1c4b483bd8e0f582$export$aeae6d33ee4c22ee = "093A49A9-4EF5-4D1D-9BC4-102361C87844";
const $1c4b483bd8e0f582$export$864ea3475ee6ea44 = {
    Customer: {
        Name: "DAVI SAS"
    },
    Vendor: {
        Name: "DAVI SAS"
    },
    Licences: [
        {
            productid: "093A49A9-4EF5-4D1D-9BC4-102361C87844",
            expireAt: "2026-02-18"
        }
    ]
};


/* Error codes
0: no error
1: no licence
2: incorrect licence
3: no data for this product
4: outdated licence
*/ // Define the initial state using that type
const $993360e742630fa4$var$initialState = {
    value: {
        licence: undefined,
        allowed: false,
        errorCode: 1
    }
};
const $993360e742630fa4$export$9bf02b14ad6809a5 = (0, $4MPRY$createSlice)({
    name: "licenceSlice",
    initialState: $993360e742630fa4$var$initialState,
    reducers: {
        setLicence: (state, action)=>{
            state.value = {
                licence: action.payload,
                allowed: false,
                errorCode: 1
            };
        },
        checkLicence: (state)=>{
            // TODO Decrypt licence
            const decodedLicence = (0, $1c4b483bd8e0f582$export$864ea3475ee6ea44);
            // Check licence data validity
            const licence = state.value.licence;
            var errorCode = 0;
            // Check if the fields are present
            !(decodedLicence.Customer && decodedLicence.Customer.Name) && (errorCode = 2);
            !(decodedLicence.Vendor && decodedLicence.Vendor.Name) && (errorCode = 2);
            !decodedLicence.Licences && (errorCode = 2);
            var goodItem = null;
            if (errorCode === 0) {
                decodedLicence.Licences.length === 0 && (errorCode = 3);
                // Check if the product id is the same as the GUID for the SpiritEngineSprite
                goodItem = decodedLicence.Licences.find((item)=>item.productid === (0, $1c4b483bd8e0f582$export$aeae6d33ee4c22ee));
                !goodItem && (errorCode = 3);
            }
            if (errorCode === 0) {
                !goodItem?.expireAt && (errorCode = 2);
                // @ts-ignore
                const date = new Date(goodItem.expireAt).getTime();
                const now = Date.now();
                // Check if the timestamp retrieved is a number
                if (isNaN(date)) errorCode = 2;
                else date < now && (errorCode = 4);
            }
            state.value = {
                licence: licence,
                allowed: errorCode === 0,
                errorCode: errorCode
            };
        }
    }
});
const { setLicence: $993360e742630fa4$export$5e2c75f54104f5e4 , checkLicence: $993360e742630fa4$export$bed470be7ed80787  } = $993360e742630fa4$export$9bf02b14ad6809a5.actions;
var $993360e742630fa4$export$2e2bcd8739ae039 = $993360e742630fa4$export$9bf02b14ad6809a5.reducer;


const $63565878075adc80$var$store = (0, $4MPRY$configureStore)({
    reducer: {
        licenceReducer: (0, $993360e742630fa4$export$2e2bcd8739ae039)
    }
});
var $63565878075adc80$export$2e2bcd8739ae039 = $63565878075adc80$var$store;





/* eslint-disable no-unused-vars */ 



const $65f6af6b2b4224a7$var$Video = /*#__PURE__*/ (0, $4MPRY$react).forwardRef(({ srcMp4: srcMp4 , srcWebm: srcWebm , onEnded: onEnded  }, ref)=>{
    return /*#__PURE__*/ (0, $4MPRY$jsxs)("video", {
        ref: ref,
        className: "ses-invisible ses-col-start-1 ses-row-start-1 ses-col-span-1 ses-row-span-1 ses-max-w-none ses-self-start ses-justify-self-center ses-object-cover",
        muted: true,
        preload: "auto",
        onEnded: onEnded,
        playsInline: true,
        controls: false,
        children: [
            /*#__PURE__*/ (0, $4MPRY$jsx)("source", {
                src: srcMp4,
                type: 'video/mp4; codecs="hvc1"'
            }),
            /*#__PURE__*/ (0, $4MPRY$jsx)("source", {
                src: srcWebm,
                type: "video/webm"
            })
        ]
    });
});
var $65f6af6b2b4224a7$export$2e2bcd8739ae039 = $65f6af6b2b4224a7$var$Video;


const $01c612cb40aac877$var$getRandomInt = (max = 1)=>{
    return Math.ceil(Math.random() * max);
};
const $01c612cb40aac877$var$fps = 40;
const $01c612cb40aac877$var$Chatbot = ({ agentData: agentData , height: height , size: size , speak: speak , animationQueue: animationQueue , setAnimationQueue: setAnimationQueue  })=>{
    const [allowSpeechAnimations, setAllowSpeechAnimations] = (0, $4MPRY$useState)(true);
    const [speaking, setSpeaking] = (0, $4MPRY$useState)(speak);
    const [moving, setMoving] = (0, $4MPRY$useState)(true);
    const moveNS = (0, $4MPRY$useRef)(null);
    const moveSP = (0, $4MPRY$useRef)(null);
    const stillNS = (0, $4MPRY$useRef)(null);
    const stillSP = (0, $4MPRY$useRef)(null);
    const [currentStill, setCurrentStill] = (0, $4MPRY$useState)("still1");
    const [currentMove, setCurrentMove] = (0, $4MPRY$useState)("idle1");
    const [queue, setQueue] = (0, $4MPRY$useState)([]);
    const [idleAndExplainFolder, setIdleAndExplainFolder] = (0, $4MPRY$useState)("move");
    const [stillFolder, setStillFolder] = (0, $4MPRY$useState)("still");
    const [trigger, setTrigger] = (0, $4MPRY$useState)(false);
    const [visible, setVisible] = (0, $4MPRY$useState)(document.hidden);
    const [windowResize, setWindowResize] = (0, $4MPRY$useState)(false);
    const sizeInPxRef = (0, $4MPRY$useRef)();
    const sizeInPx = (0, $4MPRY$useMemo)(()=>{
        if (size) {
            if (typeof size === "number") return size;
            else {
                if (size.slice(-2).toLowerCase() === "vh") {
                    const num = parseInt(size.substring(0, size.length - 2));
                    return isNaN(num) ? window.innerHeight : num * window.innerHeight / 100;
                } else if (size.slice(-1) === "%") {
                    const num = parseInt(size.substring(0, size.length - 1));
                    return isNaN(num) ? window.innerHeight : num * window.innerHeight / 100;
                }
            }
        }
        return window.innerHeight;
    }, [
        size,
        windowResize
    ]);
    const canvasWidthRef = (0, $4MPRY$useRef)();
    const canvasWidth = (0, $4MPRY$useMemo)(()=>{
        return sizeInPx > window.innerWidth ? window.innerWidth : sizeInPx;
    }, [
        sizeInPx,
        windowResize
    ]);
    const canvasHeightRef = (0, $4MPRY$useRef)();
    const canvasHeight = (0, $4MPRY$useMemo)(()=>{
        let marginTop = 0;
        if (height) {
            if (typeof height === "number") marginTop = height;
            else {
                if (height.slice(-2).toLowerCase() === "vh") {
                    const num = parseInt(height.substring(0, height.length - 2));
                    marginTop = isNaN(num) ? 0 : Math.round(num * window.innerHeight / 100);
                } else if (height.slice(-1) === "%") {
                    const num = parseInt(height.substring(0, height.length - 1));
                    marginTop = isNaN(num) ? 0 : Math.round(num * window.innerHeight / 100);
                }
            }
        }
        return sizeInPx - marginTop > window.innerHeight ? window.innerHeight - marginTop : sizeInPx - marginTop;
    }, [
        sizeInPx,
        height,
        windowResize
    ]);
    const videoRef = (0, $4MPRY$useRef)(null);
    const canvasRef = (0, $4MPRY$useRef)(null);
    const imageSize = (0, $4MPRY$useMemo)(()=>{
        const realSize = canvasHeight;
        if (realSize < 480) return "small";
        if (realSize < 1200) return "medium";
        return "large";
    }, [
        size,
        canvasHeight
    ]);
    /**
   * Update refs for sizeInPx, canvasWidth and canvasHeight to use in computeframe method
   */ (0, $4MPRY$useEffect)(()=>{
        sizeInPx && (sizeInPxRef.current = sizeInPx);
    }, [
        sizeInPx
    ]);
    (0, $4MPRY$useEffect)(()=>{
        canvasWidth && (canvasWidthRef.current = canvasWidth);
    }, [
        canvasWidth
    ]);
    (0, $4MPRY$useEffect)(()=>{
        canvasHeight && (canvasHeightRef.current = canvasHeight);
    }, [
        canvasHeight
    ]);
    // Function to set the minimum between screen height and width to use the right animations
    const detectSize = ()=>{
        setWindowResize((value)=>!value);
    };
    const onVisibilityChange = ()=>{
        setVisible(document.hidden);
    };
    (0, $4MPRY$useEffect)(()=>{
        if (visible) {
            if (moving) {
                moveNS.current && moveNS.current.pause();
                moveSP.current && moveSP.current.pause();
            } else {
                stillNS.current && stillNS.current.pause();
                stillSP.current && stillSP.current.pause();
            }
        } else if (moving) {
            moveNS.current && moveNS.current.play().catch((e)=>console.warn(e));
            moveSP.current && moveSP.current.play().catch((e)=>console.warn(e));
        } else {
            stillNS.current && stillNS.current.play().catch((e)=>console.warn(e));
            stillSP.current && stillSP.current.play().catch((e)=>console.warn(e));
        }
    }, [
        visible
    ]);
    (0, $4MPRY$useEffect)(()=>{
        document.addEventListener("visibilitychange", onVisibilityChange, false);
        // cleanup this component
        return ()=>{
            window.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);
    (0, $4MPRY$useEffect)(()=>{
        setSpeaking(allowSpeechAnimations ? speak : false);
    }, [
        speak,
        allowSpeechAnimations
    ]);
    const computeFrame = ()=>{
        const canvas = canvasRef.current;
        if (videoRef.current && sizeInPxRef?.current && canvas && canvasWidthRef?.current && canvasHeightRef?.current) {
            const context = canvas.getContext("2d");
            if (context) {
                const ratio = videoRef.current.videoWidth / sizeInPxRef.current;
                // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Optimizing_canvas#avoid_floating-point_coordinates_and_use_integers_instead
                const left = Math.round((videoRef.current.videoWidth - canvasWidthRef.current * ratio) / 2);
                context.clearRect(0, 0, canvasWidthRef.current, canvasHeightRef.current);
                context.drawImage(videoRef.current, Math.round(left), 0, Math.round(canvasWidthRef.current * ratio), Math.round(canvasHeightRef.current * ratio), 0, 0, canvasWidthRef.current, canvasHeightRef.current);
            }
        }
    };
    (0, $4MPRY$useEffect)(()=>{
        const timeoutDuration = Math.round(1000 / $01c612cb40aac877$var$fps);
        let timer;
        const computeCallback = ()=>{
            computeFrame();
            timer = setTimeout(()=>{
                requestAnimationFrame(computeCallback);
            }, timeoutDuration);
        };
        timer = setTimeout(()=>{
            requestAnimationFrame(computeCallback);
        }, timeoutDuration);
        return ()=>clearTimeout(timer);
    }, [
        canvasWidth,
        canvasHeight
    ]);
    (0, $4MPRY$useEffect)(()=>{
        if (moving) setCurrentStill("still1");
        else if (speaking) setCurrentMove("explain1");
        else setCurrentMove("idle1");
    }, [
        agentData
    ]);
    (0, $4MPRY$useEffect)(()=>{
        if (animationQueue) {
            if (animationQueue.length === 0) setQueue([]);
            else {
                // Verify if the wanted animations shall exist from the data given in the manifest.json file
                const animationDataArray = checkQueue(animationQueue);
                if (animationDataArray.length > 0) {
                    setQueue(animationDataArray);
                    setTrigger(true);
                }
            }
        }
    }, [
        animationQueue
    ]);
    // Check if each element of the given queue has a match in the data from the manifest.json file loaded
    function checkQueue(queueToCheck) {
        var test = true;
        const dataToReturn = [];
        // Get the defined folders from the manifest
        const keys = agentData ? Object.keys(agentData.data) : [];
        // Parse each item to get an array with the name of the animation and its index
        queueToCheck.forEach((item)=>{
            const data = !isNaN(parseInt(item.substring(item.length - 2))) ? [
                item.substring(0, item.length - 2),
                parseInt(item.substring(item.length - 2))
            ] : !isNaN(parseInt(item.substring(item.length - 1))) ? [
                item.substring(0, item.length - 1),
                parseInt(item.substring(item.length - 1))
            ] : [
                item,
                -1
            ];
            const lowCase = data[0].toLowerCase();
            // Check if the folder exists in the manifest and if the index of the animation is lower than the max one
            if (keys.includes(lowCase) && agentData && agentData.data[lowCase] >= data[1]) dataToReturn.push(data);
            else {
                console.log("Wrong animation wanted : ", item);
                test = false;
            }
        });
        return test ? dataToReturn : [];
    }
    // Switch animation when not in a queue
    function switchAnimation(data) {
        var rand = 0;
        switch(data){
            case "idle":
                setIdleAndExplainFolder("move");
                rand = $01c612cb40aac877$var$getRandomInt(agentData?.data.idle);
                break;
            case "explain":
                setIdleAndExplainFolder("move");
                rand = $01c612cb40aac877$var$getRandomInt(agentData?.data.explain);
                break;
            case "still":
                setStillFolder("still");
                rand = $01c612cb40aac877$var$getRandomInt(agentData?.data.still);
                break;
            default:
                break;
        }
        if (data === "still") {
            if (currentStill === `still${rand}`) rand === 1 ? setCurrentStill("still2") : setCurrentStill(`still${rand - 1}`);
            else setCurrentStill(`still${rand}`);
        } else if (currentMove === `${data}${rand}`) rand === 1 ? setCurrentMove(`${data}2`) : setCurrentMove(`${data}${rand - 1}`);
        else setCurrentMove(`${data}${rand}`);
    }
    // Switch animation when in a queue
    function switchQueue(still) {
        const item = queue[0];
        // Check if we are using an 'Explain' or 'Idle' animation. If so, the folder is 'Move'
        const folder = [
            "explain",
            "idle"
        ].includes(item[0].toLowerCase()) ? "move" : item[0];
        // Check if an animation index has been found. If not, use a random
        const animationToDisplay = item[1] === -1 ? `${item[0]}${$01c612cb40aac877$var$getRandomInt(agentData?.data[item[0].toLowerCase()])}` : `${item[0]}${item[1]}`;
        if (still) {
            setStillFolder(folder);
            setCurrentStill(animationToDisplay);
        } else {
            setIdleAndExplainFolder(folder);
            setCurrentMove(animationToDisplay);
        }
        const newQueue = [
            ...queue
        ];
        newQueue.splice(0, 1);
        if (newQueue.length === 0) {
            console.log("Send empty queue");
            setAnimationQueue && setAnimationQueue([]);
        } else setQueue(newQueue);
    }
    // Handle changes of 'moving' and 'speaking' states
    function handleMovingOrSpeaking(movingChanged) {
        if (moving === true) {
            // If the 'moving' constant has changed launch moving animations and switch animations.
            // Either way, only change the displayed animation
            if (movingChanged) {
                moveSP.current && moveSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                moveNS.current && moveNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                queue.length > 0 ? switchQueue(true) : switchAnimation("still");
            }
            videoRef.current = speaking ? moveSP.current : moveNS.current;
        } else {
            if (movingChanged) {
                stillSP.current && stillSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                stillNS.current && stillNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                if (speaking) queue.length > 0 ? switchQueue(false) : switchAnimation("explain");
                else queue.length > 0 ? switchQueue(false) : switchAnimation("idle");
            }
            videoRef.current = speaking ? stillSP.current : stillNS.current;
        }
    }
    (0, $4MPRY$useEffect)(()=>{
        handleMovingOrSpeaking(true);
    }, [
        moving
    ]);
    (0, $4MPRY$useEffect)(()=>{
        handleMovingOrSpeaking(false);
    }, [
        speaking
    ]);
    // Trigger used to launch the first animation of the queue right after the current one
    (0, $4MPRY$useEffect)(()=>{
        if (trigger) {
            switchQueue(!!moving);
            setTrigger(false);
        }
    }, [
        trigger
    ]);
    // Load move animations when the source is modified
    (0, $4MPRY$useEffect)(()=>{
        try {
            moveNS.current && moveNS.current.load();
            moveSP.current && moveSP.current.load();
        } catch (e) {
            console.warn(e);
        }
    }, [
        currentMove
    ]);
    // Load still animations when the source is modified
    (0, $4MPRY$useEffect)(()=>{
        try {
            stillSP.current && stillSP.current.load();
            stillNS.current && stillNS.current.load();
        } catch (e) {
            console.warn(e);
        }
    }, [
        currentStill
    ]);
    (0, $4MPRY$useEffect)(()=>{
        // Add event listener for screen resize to adjust videos size
        window.addEventListener("resize", detectSize);
        window.addEventListener("preventChatbotSpeakAnimationsEvent", ()=>{
            setAllowSpeechAnimations(false);
        });
        window.addEventListener("allowChatbotSpeakAnimationsEvent", ()=>{
            setAllowSpeechAnimations(true);
        });
        window.addEventListener("setSpeaking", (e)=>{
            setSpeaking(e.detail);
        });
        // Event listener handling external calls for playing (used for safari permissions issue)
        window.addEventListener("retorikSpiritEnginePlay", handleExternalCallForPlay);
        setTimeout(()=>{
            moveNS.current && moveNS.current.play().catch((e)=>{
                e !== null && console.warn(e);
            });
            moveSP.current && moveSP.current.play().catch((e)=>{
                e !== null && console.warn(e);
            });
        }, 500);
        return ()=>{
            // Remove event listeners on component unmount
            window.removeEventListener("resize", detectSize);
            window.removeEventListener("preventChatbotSpeakAnimationsEvent", ()=>setAllowSpeechAnimations(false));
            window.removeEventListener("allowChatbotSpeakAnimationsEvent", ()=>setAllowSpeechAnimations(true));
            window.removeEventListener("setSpeaking", (e)=>setSpeaking(e.detail));
            window.removeEventListener("retorikSpiritEnginePlay", handleExternalCallForPlay);
        };
    }, []);
    const handleEnd = ()=>{
        setMoving(!moving);
    };
    const handleAudioEnd = ()=>{
        document.dispatchEvent(new Event("retorikSpiritEngineAudioEnded"));
        setSpeaking(false);
    };
    const handleExternalCallForPlay = ()=>{
        if (moveNS.current && moveSP.current && stillNS.current) // Check if a video (either still or move) is currently playing. If not -> start playing.
        {
            if (!(moveNS.current.currentTime > 0 && !moveNS.current.paused && !moveNS.current.ended && moveNS.current.readyState > 2) && !(stillNS.current.currentTime > 0 && !stillNS.current.paused && !stillNS.current.ended && stillNS.current.readyState > 2)) {
                moveNS.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
                moveSP.current.play().catch((e)=>{
                    e !== null && console.warn(e);
                });
            }
        }
    };
    return /*#__PURE__*/ (0, $4MPRY$jsxs)("div", {
        className: "ses-relative ses-pointer-events-none ses-h-full ses-w-full ses-grid ses-justify-center ses-items-start ses-overflow-hidden",
        id: "retorik-animation",
        children: [
            /*#__PURE__*/ (0, $4MPRY$jsx)("audio", {
                id: "spirit-engine-sprite-audio",
                onCanPlayThrough: ()=>setSpeaking(true),
                onEnded: handleAudioEnd,
                onError: handleAudioEnd
            }),
            /*#__PURE__*/ (0, $4MPRY$jsx)("canvas", {
                id: "spirit-engine-sprite-canvas",
                className: "ses-col-start-1 ses-row-start-1 ses-col-span-1 ses-row-span-1 ses-max-h-screen ses-self-start ses-justify-self-center ses-object-cover",
                ref: canvasRef,
                height: canvasHeight,
                width: canvasWidth,
                style: {
                    marginTop: height || undefined
                }
            }),
            /*#__PURE__*/ (0, $4MPRY$jsx)((0, $65f6af6b2b4224a7$export$2e2bcd8739ae039), {
                ref: moveNS,
                onEnded: ()=>{},
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${idleAndExplainFolder}/ns/${currentMove}_ns.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${idleAndExplainFolder}/ns/${currentMove}_ns.webm`
            }),
            /*#__PURE__*/ (0, $4MPRY$jsx)((0, $65f6af6b2b4224a7$export$2e2bcd8739ae039), {
                ref: moveSP,
                onEnded: handleEnd,
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${idleAndExplainFolder}/sp/${currentMove}_sp.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${idleAndExplainFolder}/sp/${currentMove}_sp.webm`
            }),
            /*#__PURE__*/ (0, $4MPRY$jsx)((0, $65f6af6b2b4224a7$export$2e2bcd8739ae039), {
                ref: stillNS,
                onEnded: ()=>{},
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${stillFolder}/ns/${currentStill}_ns.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${stillFolder}/ns/${currentStill}_ns.webm`
            }),
            /*#__PURE__*/ (0, $4MPRY$jsx)((0, $65f6af6b2b4224a7$export$2e2bcd8739ae039), {
                ref: stillSP,
                onEnded: handleEnd,
                srcMp4: `${agentData?.url}/mp4/${imageSize}/${stillFolder}/sp/${currentStill}_sp.mp4`,
                srcWebm: `${agentData?.url}/webm/${imageSize}/${stillFolder}/sp/${currentStill}_sp.webm`
            })
        ]
    });
};
var $01c612cb40aac877$export$2e2bcd8739ae039 = $01c612cb40aac877$var$Chatbot;




const $5ad02cede29c1661$var$Loader = (props)=>{
    const [message, setMessage] = (0, $4MPRY$useState)();
    /* Error codes
    0: no error
    1: no licence
    2: incorrect licence
    3: no data for this product
    4: outdated licence
  */ (0, $4MPRY$useEffect)(()=>{
        switch(props.errorCode){
            case 1:
                setMessage("No licence found");
                break;
            case 2:
                setMessage("Invalid licence");
                break;
            case 3:
                setMessage("No data found for this product");
                break;
            case 4:
                setMessage("Licence expired");
                break;
            case 0:
            default:
                setMessage("");
                break;
        }
    }, [
        props.errorCode
    ]);
    return /*#__PURE__*/ (0, $4MPRY$jsxs)("div", {
        className: "relative h-full w-full flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $4MPRY$jsx)("div", {
                className: "mb-8 font-bold text-lg",
                children: message
            }),
            /*#__PURE__*/ (0, $4MPRY$jsx)("div", {
                className: "border-box border-b border-t border-r animate-spin w-16 h-16 border-4 rounded-full"
            })
        ]
    });
};
var $5ad02cede29c1661$export$2e2bcd8739ae039 = $5ad02cede29c1661$var$Loader;




// Use throughout your app instead of plain `useDispatch` and `useSelector`
const $890729a126ff6e91$export$f51d452c10d5b956 = ()=>(0, $4MPRY$useDispatch)();
const $890729a126ff6e91$export$a7347740d65f620b = (0, $4MPRY$useSelector);
const $890729a126ff6e91$export$5a120d91e5204be4 = ()=>$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.allowed);
const $890729a126ff6e91$export$7b348fc9f96d3a4b = ()=>$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.licence);
const $890729a126ff6e91$export$23745d1f9ed321fa = ()=>$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value.errorCode);
const $890729a126ff6e91$export$c1cf1cf4c5d51937 = ()=>$890729a126ff6e91$export$a7347740d65f620b((state)=>state.licenceReducer.value);


const $0604fad8b796cc31$var$DataRetriever = ({ licence: licence , agentData: agentData , height: height , size: size , speak: speak , animationQueue: animationQueue , setAnimationQueue: setAnimationQueue  })=>{
    const dispatch = (0, $890729a126ff6e91$export$f51d452c10d5b956)();
    const allowedByLicence = (0, $890729a126ff6e91$export$5a120d91e5204be4)();
    const errorCode = (0, $890729a126ff6e91$export$23745d1f9ed321fa)();
    (0, $4MPRY$useEffect)(()=>{
        dispatch((0, $993360e742630fa4$export$bed470be7ed80787)());
    }, [
        licence
    ]);
    return /*#__PURE__*/ (0, $4MPRY$jsx)((0, $4MPRY$react).Fragment, {
        children: allowedByLicence ? /*#__PURE__*/ (0, $4MPRY$jsx)((0, $01c612cb40aac877$export$2e2bcd8739ae039), {
            agentData: agentData,
            height: height,
            size: size,
            speak: speak,
            animationQueue: animationQueue,
            setAnimationQueue: setAnimationQueue
        }) : /*#__PURE__*/ (0, $4MPRY$jsx)((0, $5ad02cede29c1661$export$2e2bcd8739ae039), {
            errorCode: errorCode
        })
    });
};
var $0604fad8b796cc31$export$2e2bcd8739ae039 = $0604fad8b796cc31$var$DataRetriever;


const $e3a2da95730ed7d6$var$ChatbotProvider = (props)=>{
    return /*#__PURE__*/ (0, $4MPRY$jsx)((0, $4MPRY$Provider), {
        store: (0, $63565878075adc80$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $4MPRY$jsx)((0, $0604fad8b796cc31$export$2e2bcd8739ae039), {
            ...props
        })
    });
};
var $e3a2da95730ed7d6$export$2e2bcd8739ae039 = $e3a2da95730ed7d6$var$ChatbotProvider;





function $0531a00fb289598f$export$2e2bcd8739ae039(RetorikSpiritEngineSprite, props, element) {
    const root = (0, $4MPRY$createRoot)(element);
    root.render(/*#__PURE__*/ (0, $4MPRY$jsx)((0, $4MPRY$react).StrictMode, {
        children: /*#__PURE__*/ (0, $4MPRY$jsx)(RetorikSpiritEngineSprite, {
            ...props
        })
    }));
}


/* eslint-disable camelcase */ /* eslint-disable prettier/prettier */ const $ba07c5dc2bd20c2a$var$authenticate = async (licence)=>{
    const sessionId = await fetch("https://paas.retorik.fr/rest?method=authentification", {
        method: "POST",
        headers: {
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            aLicence: licence
        })
    }).then((response)=>{
        return response.json();
    }).then((data)=>{
        if (data?.authentification?.status === "success") return data.authentification;
        return false;
    }).catch((error)=>{
        console.log(error);
        return false;
    });
    return sessionId;
};
const $ba07c5dc2bd20c2a$var$sendMessage = async (licence, text)=>{
    const auth = await $ba07c5dc2bd20c2a$var$authenticate(licence);
    if (auth.status === "success") {
        const requestData = {
            idSession: auth.response,
            aFormat: "mp3",
            aText: text
        };
        await fetch("https://paas.retorik.fr/rest?method=tts_send", {
            method: "POST",
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify(requestData)
        }).then((response)=>{
            return response.json();
        }).then((data)=>{
            if (data?.tts_send?.status === "success") $ba07c5dc2bd20c2a$var$play(data?.tts_send.response);
            return data;
        }).catch((error)=>console.log(error));
    } else console.log("Authentication error");
};
const $ba07c5dc2bd20c2a$var$play = (mp3)=>{
    const audioElement = document.getElementById("spirit-engine-sprite-audio");
    if (audioElement) {
        audioElement.src = mp3;
        audioElement.play();
    }
};
var $ba07c5dc2bd20c2a$export$2e2bcd8739ae039 = $ba07c5dc2bd20c2a$var$sendMessage;


const $090815f5086f7f29$export$7dc86772e2a8d289 = (0, $0531a00fb289598f$export$2e2bcd8739ae039).bind(null, (0, $e3a2da95730ed7d6$export$2e2bcd8739ae039));
var $090815f5086f7f29$export$2e2bcd8739ae039 = (0, $e3a2da95730ed7d6$export$2e2bcd8739ae039);
window.Retorik = {
    ...window.Retorik,
    sendMessage: $ba07c5dc2bd20c2a$export$2e2bcd8739ae039,
    renderSpiritEngineSprite: $090815f5086f7f29$export$7dc86772e2a8d289
};


export {$090815f5086f7f29$export$7dc86772e2a8d289 as renderSpiritEngineSprite, $090815f5086f7f29$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=index.modern.js.map
